import { render, staticRenderFns } from "./ZavislostiPo.vue?vue&type=template&id=b6090e34&"
import script from "./ZavislostiPo.vue?vue&type=script&lang=js&"
export * from "./ZavislostiPo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports